export const conversationQueryKeys = Object.freeze({
  fetchConversations: 'fetchConversations',
  fetchConversation: 'fetchConversation',
});
